// extracted by mini-css-extract-plugin
var _1 = "disabled__uJspy";
export { _1 as "disabled" }
